// extracted by mini-css-extract-plugin
export default {"dignitaries_container":"FactsAboutNigeriaHeroSection_dignitaries_container__adq+y","image_container":"FactsAboutNigeriaHeroSection_image_container__G9aVM"};